'use client';
import Button from '@ui/Button';
import Tooltip from '@ui/Tooltip';
import useStripeDonateDialogStore from '../store/stripeDonateDialogSlice';
import React from 'react';
import useUserProfile from '@/hooks/useUserProfile';
import useHasUserSession from '@/hooks/useHasUserSession';
import {
  fetchUserLocation,
  recordDonationClick,
} from '@/actions/public/server.actions';
import {
  isDonateDisabled,
  isForeignUserToNonProfit,
} from '@/utils/donate.helper';

function StripeDonateButton(props) {
  const {
    variant = 'filled',
    nonProfit,
    amount = '',
    post = null,
    withIcon = true,
    recordPayload = null,
    overrideCss = false,
    ...rest
  } = props;

  const user = useUserProfile();
  const isLoggedIn = useHasUserSession();
  const disabled = isDonateDisabled(user, nonProfit);
  const isCountryNotSame = isForeignUserToNonProfit(user, nonProfit);
  const setShowStripeDonateDialog = useStripeDonateDialogStore(
    (state) => state.setOpen,
  );

  const handleDonate = async () => {
    if (!disabled) {
      setShowStripeDonateDialog(true, {
        nonProfit,
        amount,
        post,
      });

      if (recordPayload) {
        if (!isLoggedIn) {
          const userLocation = await fetchUserLocation();
          if (userLocation) {
            recordPayload.donationClick.location = userLocation;
          }
        }
        recordDonationClick(recordPayload);
      }
    }
  };

  const getDisabledTooltipText = () => {
    if (nonProfit.giving_fund_status === 'ON_HOLD') {
      return `This organization is currently not in compliance with California regulations – please check back later for updates on their status`;
    } else if (isCountryNotSame) {
      return `Donations can only be made to nonprofits in your country`;
    } else {
      return `Donations coming soon`;
    }
  };

  if (disabled) {
    // return (
    //   <Tooltip
    //     content={getDisabledTooltipText()}
    //     className={`min-w-[200px] max-w-[220px]`}>
    //     <Button
    //       variant={variant}
    //       color="primary"
    //       disabled
    //       role="button"
    //       as="div">
    //       <div
    //         className={cx(
    //           'flex items-center gap-1',
    //           isLesserThanMediumScreen && !overrideCss && 'text-[10px]',
    //         )}>
    //         Donate
    //         {withIcon && <HiHeart />}
    //       </div>
    //     </Button>
    //   </Tooltip>
    // );

    return (
      <Tooltip
        content={getDisabledTooltipText()}
        className={`min-w-[200px] max-w-[220px]`}>
        <Button
          variant={variant}
          color="primary"
          disabled
          role="button"
          as="div"
          {...rest}
          >
          Donate
        </Button>
      </Tooltip>
    );
  }

  // return (
  //   <Button
  //     variant={variant}
  //     color="primary"
  //     onClick={handleDonate}
  //     className="flex items-center">
  //     <div
  //       className={cx(
  //         'flex items-center gap-1',
  //         isLesserThanMediumScreen && !overrideCss && 'text-[10px]',
  //       )}>
  //       Donate
  //       {withIcon && <HiHeart />}
  //     </div>
  //   </Button>
  // );

  return (
    <Button variant={variant} color="primary" onClick={handleDonate} {...rest}>
      Donate
    </Button>
  );
}

export default StripeDonateButton;
